import Classification from 'models/classification/classification';
import Tag from 'models/tag';
import { KeyValueTag } from 'components/Tags/KeyValueTag';
import { useTranslation } from 'react-i18next';

interface IClassificationListItemProps {
  classification: Classification;
  compact?: boolean;
  onRemove?: (item: Classification) => void;
  onClick?: (item: Classification) => void;
  maxWidth?: number;
}

export const ClassificationTagItem = (props: IClassificationListItemProps) => {
  const { t } = useTranslation(['translation', 'classifications']);

  const tag = new Tag();
  tag.tagId = props.classification.classificationId;
  tag.tagName = props.classification.group.value;
  tag.tagValue = props.classification.name + ' (' + props.classification.value.toString() + ')';
  tag.tagColor = props.classification.color;
  tag.tagInfo = props.classification.inherited ? t('classifications:Inheritance.Info') : undefined;

  const onRemove = (tag: Tag) => {
    if (props.onRemove) {
      props.onRemove(props.classification);
    }
  };

  const onClick = (tag: Tag) => {
    if (props.onClick) {
      props.onClick(props.classification);
    }
  };

  //
  // Main render
  //
  return (
    <KeyValueTag
      tag={tag}
      onRemove={props.onRemove && !props.classification.inherited ? onRemove : undefined}
      onClick={props.onClick ? onClick : undefined}
      width={props.maxWidth ?? 200}
      showBorder={true}
      borderColor={props.classification.inherited ? 'blue' : 'transparent'}
      compact={props.compact}
    />
  );
};
